import { render, staticRenderFns } from "./WalletPaymentGateway.vue?vue&type=template&id=73f47e7c&scoped=true&"
import script from "./WalletPaymentGateway.vue?vue&type=script&lang=js&"
export * from "./WalletPaymentGateway.vue?vue&type=script&lang=js&"
import style0 from "./WalletPaymentGateway.vue?vue&type=style&index=0&id=73f47e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f47e7c",
  null
  
)

export default component.exports